/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @param path  path 只支持两种占位符配置，第一种是动态参数 :id 的形式，第二种是 * 通配符，通配符只能出现路由字符串的最后。
 * @param component 配置 location 和 path 匹配后用于渲染的 React 组件路径。可以是绝对路径，也可以是相对路径，如果是相对路径，会从 src/pages 开始找起。
 * @param routes 配置子路由，通常在需要为多个路径增加 layout 组件时使用。
 * @param redirect 配置路由跳转
 * @param wrappers 配置路由组件的包装组件，通过包装组件可以为当前的路由组件组合进更多的功能。 比如，可以用于路由级别的权限校验
 * @param name 配置路由的标题，默认读取国际化文件 menu.ts 中 menu.xxxx 的值，如配置 name 为 login，则读取 menu.ts 中 menu.login 的取值作为标题
 * @param icon 配置路由的图标，取值参考 https://ant.design/components/icon-cn， 注意去除风格后缀和大小写，如想要配置图标为 <StepBackwardOutlined /> 则取值应为 stepBackward 或 StepBackward，如想要配置图标为 <UserOutlined /> 则取值应为 user 或者 User
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: '/user',
    layout: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './user/login',
      },
      {
        name: 'forgot',
        path: '/user/forgot',
        component: './user/forgot',
      },
      {
        name: 'reset',
        path: '/user/reset',
        component: './user/reset',
      },
    ],
  },
  {
    path: '/',
    component: './home',
  },
  {
    name: 'Quản trị tài chính',
    icon: 'user',
    path: '/finance',
    component: './home',
    hideInMenu: true,
    hideInBreadcrumb: true,
  },
  {
    name: 'Quản lý công việc',
    icon: 'user',
    path: '/task',
    redirect: '/task/danh-sach-cong-viec/all',
    hideInMenu: true,
    hideInBreadcrumb: true,
  },
  {
    name: 'Quản lý công việc',
    icon: 'user',
    path: '/task/danh-sach-cong-viec',
    access: 'canViewTask',
    routes: [
      {
        path: '/task/danh-sach-cong-viec',
        component: './task',
        redirect: '/task/danh-sach-cong-viec/all',
      },
      {
        name: 'Tất cả công việc',
        path: '/task/danh-sach-cong-viec/all',
        component: './task',
      },
      {
        name: 'Công việc tôi giao',
        path: '/task/danh-sach-cong-viec/assignor',
        component: './task',
      },
      {
        name: 'Công việc tôi thực hiện',
        path: '/task/danh-sach-cong-viec/assignee',
        component: './task',
      },
      {
        name: 'Công việc tôi hỗ trợ',
        path: '/task/danh-sach-cong-viec/supporter',
        component: './task',
      },
      {
        name: 'Công việc tôi theo dõi',
        path: '/task/danh-sach-cong-viec/watcher',
        component: './task',
      },
      {
        name: 'Tạo công việc',
        path: '/task/danh-sach-cong-viec/create',
        component: './task/create',
        hideInMenu: true,
        access: 'canCreateTask',
      },
      {
        name: 'Sửa công việc',
        path: '/task/danh-sach-cong-viec/edit/:id',
        component: './task/edit',
        hideInMenu: true,
        access: 'canEditTask',
      },
      {
        name: 'Chi tiết công việc',
        path: '/task/danh-sach-cong-viec/view/:id',
        component: './task/view',
        hideInMenu: true,
      },
    ],
  },
  {
    name: 'Dashboard',
    icon: 'user',
    path: '/dashboard',
    component: './dashboard',
    hideInMenu: true, // hide in menu
    access: 'canViewDashboard',
  },
  {
    // Portal
    // Portal dashboard page
    name: 'Quản trị nhân lực',
    icon: 'user',
    path: '/hr',
    redirect: '/hr/employee/danh-sach-nhan-vien',
    hideInMenu: true, // hide in menu
    hideInBreadcrumb: true,
  },
  {
    name: 'Hồ sơ nhân sự',
    icon: 'team',
    path: '/hr/employee',
    routes: [
      {
        name: 'Danh sách nhân viên',
        icon: 'user',
        path: '/hr/employee/danh-sach-nhan-vien',
        routes: [
          {
            path: '/hr/employee/danh-sach-nhan-vien',
            component: './employee',
            // access: 'canViewEmployee',
          },
          {
            name: 'Tạo mới thông tin nhân viên',
            path: '/hr/employee/danh-sach-nhan-vien/create',
            component: './employee/create',
            access: 'canCreateEmployee',
            hideInMenu: true,
          },
          {
            name: 'Cập nhật thông tin nhân viên',
            path: '/hr/employee/danh-sach-nhan-vien/edit/:id',
            component: './employee/edit',
            // access: 'canEditEmployee',
            hideInMenu: true,
          },
          {
            name: 'Xem thông tin nhân viên',
            path: '/hr/employee/danh-sach-nhan-vien/view/:id',
            component: './employee/view',
            // access: 'canViewEmployee',
            hideInMenu: true,
          },
        ],
      },
    ],
  },
  {
    name: 'Hợp đồng lao động',
    icon: 'team',
    path: '/hr/contract',
    routes: [
      {
        name: 'Báo cáo hợp đồng',
        icon: 'fileText',
        path: '/hr/contract/bao-cao-het-han-hop-dong',
        access: 'canViewContractReport',
        routes: [
          {
            path: '/hr/contract/bao-cao-het-han-hop-dong',
            component: './contract/pages/contract-report',
            access: 'canViewContractReport',
          },
        ],
      },
      {
        name: 'Danh sách hợp đồng',
        icon: 'fileText',
        path: '/hr/contract/danh-sach-hop-dong',
        access: 'canViewContract',
        routes: [
          {
            path: '/hr/contract/danh-sach-hop-dong',
            component: './contract',
            access: 'canViewContract',
          },
          {
            name: 'Thêm mới hợp đồng',
            path: '/hr/contract/danh-sach-hop-dong/create',
            component: './contract/create',
            access: 'canCreateContract',
            hideInMenu: true,
          },
          {
            name: 'Chỉnh sửa hợp đồng',
            path: '/hr/contract/danh-sach-hop-dong/edit/:id',
            component: './contract/edit',
            access: 'canEditContract',
            hideInMenu: true,
          },
          {
            name: 'Xem chi tiết hợp đồng',
            path: '/hr/contract/danh-sach-hop-dong/view/:id',
            component: './contract/view',
            access: 'canViewContract',
            hideInMenu: true,
          },
        ],
      },
      {
        name: 'Danh sách phụ lục',
        icon: 'fileText',
        path: '/hr/contract/danh-sach-phu-luc',
        access: 'canViewContractAppendix',
        routes: [
          {
            path: '/hr/contract/danh-sach-phu-luc',
            component: './contract/pages/contract-appendix',
            access: 'canViewContractAppendix',
          },
          {
            name: 'Thêm mới phụ lục',
            path: '/hr/contract/danh-sach-phu-luc/create',
            component: './contract/pages/contract-appendix/create',
            access: 'canCreateContractAppendix',
            hideInMenu: true,
          },
          {
            name: 'Chỉnh sửa phụ lục',
            path: '/hr/contract/danh-sach-phu-luc/edit/:id',
            component: './contract/pages/contract-appendix/edit',
            access: 'canEditContractAppendix',
            hideInMenu: true,
          },
          {
            name: 'Chi tiết phụ lục',
            path: '/hr/contract/danh-sach-phu-luc/view/:id',
            component: './contract/pages/contract-appendix/view',
            access: 'canViewContractAppendix',
            hideInMenu: true,
          },
        ],
      },

      {
        name: 'Cấu hình',
        icon: 'fileText',
        path: '/hr/contract/config',
        access: 'canViewContractConfig',
        routes: [
          {
            name: 'Quy tắc tính thuế',
            icon: 'audit',
            path: '/hr/contract/config/danh-sach-quy-tac-tinh-thue',
            access: 'canViewContractConfig',
            routes: [
              {
                path: '/hr/contract/config/danh-sach-quy-tac-tinh-thue',
                component: './contract/pages/contract-tax-rule',
                access: 'canViewContractConfig',
              },
              {
                name: 'Thêm quy tắc tính thuế mới',
                path: '/hr/contract/config/danh-sach-quy-tac-tinh-thue/create',
                component: './contract/pages/contract-tax-rule/create',
                access: 'canCreateContractConfig',
                hideInMenu: true,
              },
              {
                name: 'Chỉnh sửa quy tắc tính thuế',
                path: '/hr/contract/config/danh-sach-quy-tac-tinh-thue/edit/:id',
                component: './contract/pages/contract-tax-rule/edit',
                access: 'canEditContractConfig',
                hideInMenu: true,
              },
              {
                name: 'Xem quy tắc tính thuế',
                path: '/hr/contract/config/danh-sach-quy-tac-tinh-thue/view/:id',
                component: './contract/pages/contract-tax-rule/view',
                access: 'canViewContractConfig',
                hideInMenu: true,
              },
            ],
          },
          // {
          //   name: 'Mẫu in hợp đồng',
          //   icon: 'fileText',
          //   path: '/hr/contract/config/danh-sach-mau-in',
          //   access: 'canViewContractConfig',
          //   routes: [
          //     {
          //       path: '/hr/contract/config/danh-sach-mau-in',
          //       component: './contract/pages/contract-template',
          //       access: 'canViewContractConfig',
          //     },
          //     {
          //       name: 'Thêm mới mẫu in',
          //       path: '/hr/contract/config/danh-sach-mau-in/create',
          //       component: './contract/pages/contract-template/create',
          //       access: 'canCreateContractConfig',
          //       hideInMenu: true,
          //     },
          //     {
          //       name: 'Chỉnh sửa mẫu in',
          //       path: '/hr/contract/config/danh-sach-mau-in/edit/:id',
          //       component: './contract/pages/contract-template/edit',
          //       access: 'canEditContractConfig',
          //       hideInMenu: true,
          //     },
          //     {
          //       name: 'Xem chi tiết mẫu in',
          //       path: '/hr/contract/config/danh-sach-mau-in/view/:id',
          //       component: './contract/pages/contract-template/view',
          //       access: 'canViewContractConfig',
          //       hideInMenu: true,
          //     },
          //   ],
          // },
          {
            name: 'Mẫu in hợp đồng',
            icon: 'fileText',
            path: '/hr/contract/config/mau-in',
            access: 'canViewContractConfig',
            routes: [
              {
                path: '/hr/contract/config/mau-in',
                component: './contract/pages/contract-template-new',
                access: 'canViewContractConfig',
              },
              {
                name: 'Chỉnh sửa mẫu in',
                path: '/hr/contract/config/mau-in/edit/:id',
                component: './contract/pages/contract-template-new/edit',
                access: 'canEditContractConfig',
                hideInMenu: true,
              },
            ],
          },
          {
            name: 'Loại hợp đồng',
            icon: 'fileText',
            path: '/hr/contract/config/danh-sach-loai-hop-dong',
            component: './contract/pages/contract-type',
            access: 'canViewContractConfig',
          },
        ],
      },
    ],
  },
  {
    name: 'Đề xuất',
    icon: 'CalendarOutlined',
    path: '/hr/proposal',
    routes: [
      {
        name: 'Danh sách đề xuất',
        icon: 'DotChartOutlined',
        path: '/hr/proposal/danh-sach-de-xuat',
        routes: [
          {
            path: '/hr/proposal/danh-sach-de-xuat',
            component: './proposal',
            access: 'canViewProposal',
          },
        ],
      },
      {
        name: 'Nghỉ phép năm',
        icon: 'DotChartOutlined',
        path: '/hr/proposal/danh-sach-de-xuat-nghi-phep-nam',
        routes: [
          {
            path: '/hr/proposal/danh-sach-de-xuat-nghi-phep-nam',
            component: './proposal/pages/annual-leave',
            access: 'canViewProposal',
          },
        ],
      },
      {
        name: 'Nghỉ chế độ',
        icon: 'DotChartOutlined',
        path: '/hr/proposal/danh-sach-de-xuat-nghi-che-do',
        routes: [
          {
            path: '/hr/proposal/danh-sach-de-xuat-nghi-che-do',
            component: './proposal/pages/special-leave',
            access: 'canViewProposal',
          },
        ],
      },
      {
        name: 'Nghỉ không lương',
        icon: 'DotChartOutlined',
        path: '/hr/proposal/danh-sach-de-xuat-khong-luong',
        routes: [
          {
            path: '/hr/proposal/danh-sach-de-xuat-khong-luong',
            component: './proposal/pages/unpaid-leave',
            access: 'canViewProposal',
          },
        ],
      },
      {
        name: 'Làm việc ngoài văn phòng',
        icon: 'DotChartOutlined',
        path: '/hr/proposal/danh-sach-de-xuat-lam-online',
        routes: [
          {
            path: '/hr/proposal/danh-sach-de-xuat-lam-online',
            component: './proposal/pages/work-outside',
            access: 'canViewProposal',
          },
        ],
      },
      {
        name: 'Đi công tác',
        icon: 'DotChartOutlined',
        path: '/hr/proposal/danh-sach-de-xuat-di-cong-tac',
        routes: [
          {
            path: '/hr/proposal/danh-sach-de-xuat-di-cong-tac',
            component: './proposal/pages/business-trip',
            access: 'canViewProposal',
          },
        ],
      },
      {
        name: 'Giải trình chấm công',
        icon: 'DotChartOutlined',
        path: '/hr/proposal/danh-sach-de-xuat-ca-nhan',
        routes: [
          {
            path: '/hr/proposal/danh-sach-de-xuat-ca-nhan',
            component: './proposal/pages/individual',
            access: 'canViewProposal',
          },
        ],
      },
      {
        name: 'Làm thêm giờ (OT)',
        icon: 'DotChartOutlined',
        path: '/hr/proposal/ot/de-xuat',
        access: 'canViewOvertime',
        routes: [
          {
            path: '/hr/proposal/ot/de-xuat',
            component: './attendance/pages/overtime/pages/proposal',
            access: 'canViewOvertime',
          },
          {
            path: '/hr/proposal/ot/de-xuat/view/:id',
            component: './attendance/pages/overtime/pages/proposal/view',
            access: 'canViewOvertime',
            hideInMenu: true,
          },
        ],
      },
      {
        name: 'Cấu hình',
        icon: 'DotChartOutlined',
        path: '/hr/proposal/config',
        routes: [
          {
            name: 'Loại đề xuất',
            icon: 'DotChartOutlined',
            path: '/hr/proposal/config/danh-sach-loai-de-xuat',
            component: './proposal/pages/category',
            access: 'canViewAttendanceConfig',
          },
          {
            name: 'Quy tắc làm thêm giờ',
            icon: 'DotChartOutlined',
            path: '/hr/proposal/config/cau-hinh-lam-them-gio',
            access: 'canViewAttendanceConfig',
            routes: [
              {
                path: '/hr/proposal/config/cau-hinh-lam-them-gio',
                component: './attendance/pages/overtime',
              },
              {
                path: '/hr/proposal/config/cau-hinh-lam-them-gio',
                component: './attendance/pages/overtime/pages/config/view',
                access: 'canViewAttendanceConfig',
                hideInMenu: true,
              },
              {
                name: 'Tạo mới cấu hình làm thêm giờ',
                path: '/hr/proposal/config/cau-hinh-lam-them-gio/create',
                component: './attendance/pages/overtime/pages/config/create',
                access: 'canCreateAttendanceConfig',
                hideInMenu: true,
              },
              {
                name: 'Chỉnh sửa cấu hình làm thêm giờ',
                path: '/hr/proposal/config/cau-hinh-lam-them-gio/edit/:id',
                component: './attendance/pages/overtime/pages/config/edit',
                access: 'canEditAttendanceConfig',
                hideInMenu: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: 'Chấm công',
    icon: 'ClockCircleOutlined',
    path: '/hr/attendance',
    routes: [
      {
        name: 'Ca làm việc',
        path: '/hr/attendance/shift',
        component: './shift',
        access: 'canViewWorkShift',
      },
      {
        name: 'Phân ca/lịch làm việc',
        path: '/hr/attendance/shift-schedule',
        component: './shift/schedule',
        access: 'canViewShiftAssign',
      },
      {
        name: 'Quản lý lịch nghỉ lễ',
        path: '/hr/attendance/shift-holiday',
        component: './holiday',
        access: 'canViewHoliday',
      },
      {
        name: 'Bảng công',
        icon: 'TableOutlined',
        path: '/hr/attendance/timesheet/detail',
        component: './attendance/pages/timesheet-detail',
        access: 'canViewTimesheetDetail',
      },
      {
        name: 'Dữ liệu chấm công thô',
        icon: 'DotChartOutlined',
        path: '/hr/attendance/timesheet/danh-sach-du-lieu-cham-cong',
        component: './attendance/pages/data',
        access: 'canViewAttendanceRaw',
      },
      {
        name: 'Cấu hình',
        icon: 'SettingOutlined',
        path: '/hr/attendance/config',
        access: 'canViewAttendanceConfig',
        routes: [
          {
            name: 'Quy tắc chấm công',
            icon: 'SettingOutlined',
            path: '/hr/attendance/config/cau-hinh-cham-cong',
            access: 'canViewAttendanceConfig',
            routes: [
              {
                path: '/hr/attendance/config/cau-hinh-cham-cong',
                component: './attendance/pages/attendance-config-list',
              },
              {
                name: 'Tạo mới cấu hình chấm công',
                path: '/hr/attendance/config/cau-hinh-cham-cong/create',
                component: './attendance/pages/attendance-settings',
                hideInMenu: true,
                access: 'canCreateAttendanceConfig',
              },
              {
                name: 'Chỉnh sửa cấu hình chấm công',
                path: '/hr/attendance/config/cau-hinh-cham-cong/edit/:id',
                component: './attendance/pages/attendance-settings',
                hideInMenu: true,
                access: 'canEditAttendanceConfig',
              },
            ],
          },
          {
            name: 'Client chấm công',
            icon: 'DotChartOutlined',
            path: '/hr/attendance/config/client',
            component: './attendance/pages/client',
            access: 'canViewAttendanceClient',
          },
        ],
      },
    ],
  },
  {
    name: 'Quản lý quỹ phép',
    icon: 'ClockCircleOutlined',
    path: '/hr/dayoff',
    routes: [
      {
        name: 'Quỹ phép của nhân viên',
        path: '/hr/dayoff/employee',
        component: './dayoff',
        access: 'canViewLeaveFund',
      },
      {
        name: 'Quy tắc cấp phép',
        icon: '',
        path: '/hr/dayoff/config/quy-tac-cap-phep',
        component: './dayoff/configuration',
        access: 'canViewAttendanceConfig',
      },
    ],
  },
  {
    name: 'Cấu hình HR',
    icon: 'SettingOutlined',
    path: 'hr/config',
    routes: [
      {
        name: 'Cơ cấu tổ chức',
        icon: 'apartment',
        path: '/hr/config/organization',
        routes: [
          {
            name: 'Chức danh',
            icon: 'idcard',
            path: '/hr/config/organization/title',
            component: './title',
            access: 'canViewTitle',
          },
          {
            name: 'Loại đơn vị',
            icon: 'apartment',
            path: '/hr/config/organization/unit-type',
            access: 'canViewOrganizationLevel',
            routes: [
              {
                path: '/hr/config/organization/unit-type',
                component: './organization-level',
                access: 'canViewOrganizationLevel',
              },
              {
                name: 'Chi tiết loại đơn vị',
                path: '/hr/config/organization/unit-type/view/:id',
                component: './organization-level/view',
                hideInMenu: true,
                access: 'canViewOrganizationLevel',
              },
              {
                path: '/hr/config/organization/unit-type/organization/:organizationId',
                component: './organization-level',
                access: 'canViewOrganizationLevel',
                hideInMenu: true,
              },
            ],
          },
          {
            name: 'Danh sách công ty',
            icon: 'bank',
            path: '/hr/config/organization/company',
            access: 'canViewCompany',
            routes: [
              {
                path: '/hr/config/organization/company',
                component: './company',
                access: 'canViewCompany',
              },
              {
                name: 'Chi tiết công ty',
                path: '/hr/config/organization/company/view/:id',
                component: './company/view',
                hideInMenu: true,
                access: 'canViewCompany',
              },
            ],
          },
          {
            name: 'Danh sách đơn vị',
            icon: 'apartment',
            path: '/hr/config/organization/department',
            access: 'canViewDepartment',
            routes: [
              {
                path: '/hr/config/organization/department',
                component: './department-list',
                access: 'canViewDepartment',
              },
              {
                name: 'Chi tiết đơn vị',
                path: '/hr/config/organization/department/view/:id',
                component: './department-list/view',
                hideInMenu: true,
                access: 'canViewDepartment',
              },
            ],
          },
        ],
      },
      {
        name: 'Nhóm chức danh',
        icon: 'tags',
        path: '/hr/config/metadata/title_group',
        component: './metadata',
        access: 'canViewConfig',
      },
      {
        name: 'Trình độ học vấn',
        icon: 'book',
        path: '/hr/config/metadata/degree',
        component: './metadata',
        access: 'canViewConfig',
      },
      {
        name: 'Tình trạng hôn nhân',
        icon: 'heart',
        path: '/hr/config/metadata/marriage_status',
        component: './metadata',
        access: 'canViewConfig',
      },
      {
        name: 'Mối quan hệ',
        icon: 'heart',
        path: '/hr/config/metadata/relation',
        component: './metadata',
        access: 'canViewConfig',
      },
      {
        name: 'Loại chứng chỉ',
        icon: 'book',
        path: '/hr/config/metadata/certification',
        component: './metadata',
        access: 'canViewConfig',
      },
    ],
  },
  {
    name: 'Phân quyền',
    icon: 'user',
    path: '/phan-quyen',
    redirect: '/phan-quyen/quan-ly-tai-khoan-nguoi-dung',
    hideInMenu: true,
  },
  {
    name: 'Người dùng & Vai trò',
    icon: 'user',
    path: '/phan-quyen/quan-ly-tai-khoan-nguoi-dung',
    access: 'canViewUser',
    routes: [
      {
        path: '/phan-quyen/quan-ly-tai-khoan-nguoi-dung',
        component: './user-management',
      },
      {
        name: 'Xem chi tiết',
        path: '/phan-quyen/quan-ly-tai-khoan-nguoi-dung/view/:id',
        component: './user-management/view',
        access: 'canViewUser',
        hideInMenu: true,
      },
    ],
  },
  {
    name: 'Kiểm soát đăng nhập',
    icon: 'LaptopOutlined',
    path: '/phan-quyen/kiem-soat-dang-nhap',
    routes: [
      {
        path: '/phan-quyen/kiem-soat-dang-nhap',
        component: './device-login-control',
      },
    ],
  },
  {
    name: 'Phân quyền',
    icon: 'SafetyOutlined',
    path: '/phan-quyen/quan-ly-vai-tro',
    routes: [
      {
        path: '/phan-quyen/quan-ly-vai-tro',
        component: './role',
        access: 'canViewRoleGroup',
      },
      {
        name: 'Tạo mới nhóm vai trò',
        path: '/phan-quyen/quan-ly-vai-tro/create',
        component: './role/create',
        hideInMenu: true,
        access: 'canCreateRoleGroup',
      },
      {
        name: 'Cập nhật nhóm vai trò',
        path: '/phan-quyen/quan-ly-vai-tro/edit/:id',
        component: './role/edit',
        hideInMenu: true,
        access: 'canEditRoleGroup',
      },
    ],
  },
  {
    name: 'Cấu hình hệ thống',
    icon: 'SettingOutlined',
    path: '/phan-quyen/cau-hinh-he-thong',
    access: 'canViewSystemConfig',
    routes: [
      {
        path: '/phan-quyen/cau-hinh-he-thong',
        component: './system-config',
        access: 'canViewSystemConfig',
      },
      {
        name: 'Cấu hình chung',
        path: '/phan-quyen/cau-hinh-he-thong/edit/:id',
        component: './system-config/edit',
        access: 'canEditSystemConfig',
        hideInMenu: true,
      },
      {
        name: 'Cấu hình chung',
        path: '/phan-quyen/cau-hinh-he-thong/view/:id',
        component: './system-config/view',
        access: 'canViewSystemConfig',
        hideInMenu: true,
      },
    ],
  },
  {
    name: 'Cấu hình email bảng công',
    icon: 'MailOutlined',
    path: '/phan-quyen/cau-hinh-email-bang-cong',
    component: './timesheet-mail-config',
    access: 'canViewSystemConfig',
  },
  {
    name: 'Cấu hình thông báo',
    icon: 'BellOutlined',
    path: '/phan-quyen/cau-hinh-thong-bao',
    access: 'canViewNotification',
    routes: [
      {
        path: '/phan-quyen/cau-hinh-thong-bao',
        component: './announcement',
        access: 'canViewNotification',
      },
      {
        name: 'Tạo mới thông báo',
        path: '/phan-quyen/cau-hinh-thong-bao/create',
        component: './announcement/create',
        hideInMenu: true,
        access: 'canCreateNotification',
      },
      {
        name: 'Cập nhật thông báo',
        path: '/phan-quyen/cau-hinh-thong-bao/edit/:id',
        component: './announcement/edit',
        hideInMenu: true,
        access: 'canEditNotification',
      },
    ],
  },
  {
    component: '404',
    path: '/*',
  },
];
